import { InjectionToken } from '@angular/core';

import { CartAnalyticTracker } from '../models/cart/i-cart-analytic-tracker';

export const CART_ANALYTIC_TRACKERS = new InjectionToken<CartAnalyticTracker[]>(
  'CART_ANALYTIC_TRACKERS',
  {
    providedIn: 'root',
    factory: () => []
  }
);

export const CART_KEY_STORAGE_KEY = 'cie-cart-key';

export const CART_LINE_TYPES = {
  PRODUCT: 'PRODUCT',
  EXTRA_PRODUCT: 'EXTRA_PRODUCT',
  GREETING_CARD: 'GREETING_CARD',
  PICTURE: 'PICTURE',
  QUESTION: 'QUESTION',
  COMMENT: 'COMMENT',
  INTERNAL_COMMENT: 'INTERNAL_COMMENT',
  GROUPED_EXTRA_PRODUCTS: 'GROUPED_EXTRA_PRODUCTS',
  INVOICE_FEE: 'INVOICE_FEE',
  REFUND: 'REFUND',
  DEPOSIT: 'DEPOSIT',
  DELIVERY_DEPOSIT: 'DELIVERY_DEPOSIT',
  DISCOUNT: 'DISCOUNT',
  THIRD_PARTY_DELIVERY_FEE: 'THIRD_PARTY_DELIVERY_FEE',
  THIRD_PARTY_DELIVERY_SUBSIDY: 'THIRD_PARTY_DELIVERY_SUBSIDY',
  RETURN_PACKAGING: 'RETURN_PACKAGING',
};

export const CART_LINE_CUSTOM_TYPES = {
  CUSTOM_PRODUCTS: 'CUSTOM_PRODUCTS'
};

export enum CART_DELIVERY_TYPES {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
  /**Order without delivery details at all.
   * Created from an order request whose form has deliveryDetailsRequired: false */
  NO_DELIVERY = 'NO_DELIVERY'
}

export enum DELIVERY_ORDER_DELIVERY_TYPES {
  COURIER = 'COURIER',
  MAIL = 'MAIL',
  GIFT = 'GIFT',
  THIRD_PARTY = 'THIRD_PARTY'
}

export enum UI_DELIVERY_OPTIONS {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
  MAIL = 'MAIL',
  GIFT = 'GIFT'
}

export enum DISCOUNT_TYPES {
  PROMO_CODE = 'PROMO_CODE',
  BAKERY_DISCOUNT = 'BAKERY_DISCOUNT',
  COMPANY_DISCOUNT = 'COMPANY_DISCOUNT',
  USER_DISCOUNT = 'USER_DISCOUNT',
}

export const CART_SOURCE_TYPE = {
  STANDARD: 'STANDARD',
  EXPRESS: 'EXPRESS',
  REQUEST: 'REQUEST'
};

export const CART_ERRORS = {
  OUT_OF_STOCK: 'OUT_OF_STOCK'
};

export enum CART_API_HEADERS {
  CART_SOURCE_TYPE = 'x-cart-source-type',
  CART_KEY_HEADER = 'x-cart-key-header',
  SOURCE_HEADER = 'x-source-header'
}

export enum EXTRA_PRODUCT_GROUP_TYPES {
  YES_NO = 'YES_NO',
  GENERIC = 'GENERIC'
}

export enum ADDONS_TYPES {
  EXTRA_PRODUCT = 'EXTRA_PRODUCT',
  PRINTING_PICTURE = 'PRINTING_PICTURE',
  QUESTION = 'QUESTION',
  DEPOSIT = 'DEPOSIT',
}
